"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateAvailabilityStatusFieldValue = exports.getAvailabilityStatusFieldEmptyValue = void 0;
const getAvailabilityStatusFieldEmptyValue = () => {
    return { emoji: "", status: "", selected_interval: "" };
};
exports.getAvailabilityStatusFieldEmptyValue = getAvailabilityStatusFieldEmptyValue;
const generateAvailabilityStatusFieldValue = (value) => {
    const initialValue = (0, exports.getAvailabilityStatusFieldEmptyValue)();
    return { ...initialValue, ...value };
};
exports.generateAvailabilityStatusFieldValue = generateAvailabilityStatusFieldValue;
